(() => {
  const selector = '[data-ht-release-expires-at]';
  let timer;
  let queued = false;

  const refresh = () => {
    queued = false;
    window.clearTimeout(timer);
    const now = Date.now();
    let nextExpiry = Infinity;
    document.querySelectorAll(selector).forEach((badge) => {
      const expiresAt = Number(badge.dataset.htReleaseExpiresAt);
      badge.hidden = !Number.isFinite(expiresAt) || expiresAt <= now;
      if (!badge.hidden) nextExpiry = Math.min(nextExpiry, expiresAt);
    });
    if (Number.isFinite(nextExpiry)) {
      timer = window.setTimeout(refresh, Math.min(nextExpiry - now, 2147483647));
    }
  };

  const queueRefresh = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(refresh);
  };

  const start = () => {
    // Cards can arrive after filtering, recommendations, or browser history restoration.
    new MutationObserver((records) => {
      if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) =>
        node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
      ))) queueRefresh();
    }).observe(document.body, { childList: true, subtree: true });
    refresh();
  };

  window.addEventListener('pageshow', queueRefresh);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) queueRefresh();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
